module.exports = __webpack_public_path__ + "static/the-wave-machine-social-2d783c232f657f380a503319402b9022.png";